import { apiClient } from '~/api/client';

export type UpdateRelationsParams = {
  list_id: string;
  relationships?: {
    ids?: string[];
    method?: string;
  };
};

export const updateRelations = async (params: UpdateRelationsParams) =>
  apiClient.put(`/lists/${params.list_id}/update_relations`, {
    relationships: params.relationships,
  });
